import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import nexapi from '../../services/api';

import { UserModelN } from "../../types/models/UserModelN";


interface AuthState {
    token: string | null;
    // userRole: string[] | [];
    isAuthenticated: boolean;
    user: UserModelN | null,
    error: string | null;
    status: string | null;
  }


const token = localStorage.getItem("access_token");
const userRole = localStorage.getItem("role");

const initialState: AuthState = {
    token: token || null,
    // userRole: userRole || null,
    isAuthenticated: !!token,
    user: null,
    error: null,
    status: null
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuthToken: (state, action) => {
            state.token = action.payload.token;
            // state.userRole = action.payload.role;
            state.isAuthenticated = true;
            state.user = action.payload.user;

            localStorage.setItem("access_token", action.payload.user.token);
            localStorage.setItem("role", action.payload.userRole);

            // Redirect based on role
            // if (state.userRole === "Super Admin") {
            //     window.location.href = "/super-admin-dashboard";
            // } else if (state.userRole === "Company Admin") {
            //     window.location.href = "/company-admin-dashboard";
            // } else {
            //     window.location.href = "/dashboard";
            // }
        },
        setError: (state, action) => {
          state.token = action.payload;
        },
        logout: (state) => {
            state.token = null;
            // state.userRole = null;
            state.isAuthenticated = false;

            localStorage.removeItem("access_token");
            localStorage.removeItem("role");

            // window.location.href = "/login";
        },
    },
    extraReducers: (builder) => {
        builder
      }
});

export const { setAuthToken, logout } = authSlice.actions;
export default authSlice.reducer;
